import { getSelectedLanguage } from "@maersk-global/shared-js";
import CONSTANTS from "./CONSTANTS";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

/** Function that displays the data and the time in the right format
 * @param date - The date that needs formatting
 * @param formatDate - The format the date needs to appear
 * @param timeZone - The timezone in which the time needs to appear
 */
export function dateFormat(date, formatDate, timeZone) {
  let utcDate = dayjs(date).utc();
  if (timeZone) {
    utcDate = utcDate.tz(timeZone);
  }
  return utcDate.format(formatDate) !== "Invalid Date" ? utcDate.format(formatDate) : date;
}

export function firstLetterUpperCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function firstLetterLowerCase(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export function stringToLowerCase(string) {
  return string.toLowerCase().trim();
}

export function replaceWhiteSpaceWithUnderscore(string) {
  return string.replace(/\s/g, "_");
}

/**
 * Converts string to uppercase and trims empty spaces
 * @param {String} String
 */

export function stringToUpperCase(string) {
  return string.toUpperCase().trim();
}

export function toTitleCase(string) {
  return typeof string === "string"
    ? string.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      })
    : string;
}

/**
 * Formats a number (or a string representing a number) to the correct locale representation
 * based on the language that has been selected on the site
 * @param {Number or String} numberOrString
 */
export function numberFormat(numberOrString) {
  if (typeof numberOrString === "string") {
    numberOrString = Number(numberOrString);
  }
  const lang = getSelectedLanguage(CONSTANTS.DEFAULT_LANGUAGE);
  return new Intl.NumberFormat(lang).format(numberOrString);
}
